<template>
  <div>
    <ul class="goodsList">
      <li v-for="item in goodsList" :key="item.id">
        <div class="business">
          <img :src="item.business.headImg.url" alt="" />
          <span>{{ item.business.name }}</span>
        </div>
        <div class="shop">
          <div
            class="shop-img"
            :style="{
              backgroundImage:
                'url(' +
                handleImg({ url: item.skuImg.url, width: 176, height: 176 }) +
                ')',
            }"
          ></div>
          <div class="shop-right">
            <div class="shop-title">{{ item.merchandiseName }}</div>
            <div class="shop-cbox">
              <div
                class="shop-color"
                v-if="item.skuAttrs && item.skuAttrs.length"
              >
                <span
                  class="attributeBox"
                  v-for="(goods, index) in item.skuAttrs"
                  :key="index"
                >
                  {{ goods.attributeNameEn }}:
                  {{ goods.attributeValueEn }}
                </span>
              </div>
              <div class="buyNum">x{{ item.buyNum }}</div>
            </div>
            <div
              class="shop-price"
              v-if="
                item.merchandiseSnapshot && item.merchandiseSnapshot.priceMoney
              "
            >
              {{ item.merchandiseSnapshot.priceMoney.symbol
              }}{{
                $currencyFormatter(item.merchandiseSnapshot.priceMoney.number)
              }}
            </div>
          </div>
        </div>
        <div class="remark">
          <span>{{ $t("message.order.remarkPh") }}：</span>
          <span>{{ item.remark?item.remark:'' }}</span>
        </div>

        <div class="button-box" v-if="item.orderMcStatus==3">
          <button
            @click.stop="logisticsDetail(item.id)"
          >
            {{ $t('message.order.logisticsBtn') }}
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "GoodsList",
  components: {},
  props: {
    goodsList: {
      type: Array,
      default: () => [],
    },
    showTip: {
      type: Boolean,
      default: true,
    },
    showLogistics:{
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
        logisticsDetail(orderMcId){
            this.$router.push({path: '/logistics', query: {orderMcId}})
        },
  },
};
</script>

<style lang="less" scoped>
.goodsList {
  padding: 12px;
  background: #fff;
  margin-top: 12px;
  li ~ li {
    margin-top: 5px;
  }
  li {
    display: flex;
    flex-direction: column;
    .shop-img {
      width: 88px;
      height: 88px;
      background-size: 100% 100%;
      margin-right: 7px;
    }
    .shop-right {
      flex: 1;
      .shop-title {
        font-size: 13px;
        color: #161a1a;
        letter-spacing: 0;
        line-height: 20px;
        text-align: left;
        font-family: "TradeGothicLT";
      }
      .shop-cbox {
        display: flex;
        font-size: 12px;
        color: #a4a4a4;
        margin-top: 10px;
        font-family: "TradeGothicLT";
        .shop-color {
          flex: 1;
          text-align: left;
        }
      }
      .shop-price {
        display: flex;
        justify-content: flex-end;
        font-size: 12px;
        color: #b4282d;
        margin-top: 10px;
      }
    }
    .attributeBox {
      line-height: 18px;
    }
    .buyNum {
      display: flex;
      align-items: center;
    }
    .remark {
      font-size: 16px;
      margin-top: 12px;
      display: flex;
      span:first-child {
        text-align: left;
        font-family: "TradeGothicLT";
        width: 120px;
        min-width: 120px;
      }
      span {
        color: #161a1a;
        word-wrap:break-word;
        word-break:break-word; 
        text-align: left;
      }
    }
  }
  .business {
    line-height: 0;
    display: flex;
    align-items: center;
    & span {
      height: 15px;
      font-size: 11px;
      color: #161a1a;
      line-height: 15px;
      margin-bottom: 7.5px;
      font-family: "TradeGothicLT";
    }
    & img {
      width: 30px;
      height: 30px;
      margin-right: 6px;
      margin-bottom: 7px;
      border-radius: 36px;
    }
  }
  .shop {
    display: flex;
  }
}

.button-box {
  background-color: white;
  margin-bottom: 5px;
  display: flex;
  justify-content: flex-end;
  // padding: 0 12px;
  font-family: "TradeGothicLT";
  a,
  button {
    display: inline-block;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    background: #ffffff;
    border: 0.5px solid #161a1a;
    border-radius: 15px;
    font-size: 13px;
    color: #363636;
    margin-left: 10px;
    padding: 0 12.5px;
  }
}
</style>
